import * as React from 'react';
import { connect } from "react-redux";
import ReactHtmlParser from 'react-html-parser';
import fetch from 'cross-fetch';
import { Tokenizer } from '@fnv-core/tokens';
import { QRCodeContainer } from '../../containers/QRCodeContainer';
import { DigitaleLedenpasLidnummerNaam } from '../../presentational/DigitaleLedenpasLidnummerNaam';
import { MijnFNVPageContext } from '../pages/helpers/MijnFNVPageContext';
import { FormControlHelpers } from '../../formcontrols/helpers/FormControlHelpers';
import { getResourceString } from '../../kentico/resource-strings';
import { downloadElementAsPdf } from '../../helpers/ElementToPdfHelper';
import { MutableRefObject } from 'react';

export interface MijnFNVDigitaleLedenPasBlockProps {
    apiUrl: string;
    title:  string;
    intro: string;
    userId: string;
}

export interface MijnFNVDigitaleLedenPasBlockState {
    lidnummer : string;
    name : string;
    birthDate: string;
    membershipCardActivatedDate: string;
}

const mapStateToProps = (state : any) => {
    return {
      userId: state.user.userId
    };
  };

class ContainedMijnFNVDigitaleLedenPasBlock extends React.Component<MijnFNVDigitaleLedenPasBlockProps, MijnFNVDigitaleLedenPasBlockState> {
  private downloadRef: MutableRefObject<HTMLDivElement>;

  constructor(props) {
    super(props);
    this.downloadRef = React.createRef();
  }

    state = {
        lidnummer : "",
        name : "",
        birthDate : "",
        membershipCardActivatedDate : ""
    };

    componentDidMount() {
      const formattedUrl = Tokenizer.replaceTokens(this.props.apiUrl, [this.props.userId]);
        fetch(formattedUrl)
        .then(response => {
          if (response.status > 300) {
            return {"_error" : true};
          } else {
            return response.json();
          }
        })
        .then(json => {
            if (!json._error) {
                this.setState({
                    lidnummer : json.Lidmaatschapsnummer,
                    name : json.Naam,
                    birthDate : FormControlHelpers.convertValueToType(json.GeboorteDatum , {dataType: "date"}),
                    membershipCardActivatedDate : FormControlHelpers.convertValueToType(json.RechtenDatum , {dataType: "date"})
                });
            }
        })
        .catch(err => {
          // tslint:disable-next-line
          console.error(err);
        });
    }

    render () {        
        let download = (e) => {
          e.preventDefault();
          downloadElementAsPdf(this.downloadRef.current, 'ledenpas');
        };

        /*

            link tbv digitale wallet : weer toevoegen zodra dit live moet
            
            <a  target="_system" className="digitaleledenpas__add-to-wallet"
                                    href="/api/passkit/pass"><img alt="Toevoegen aan apple wallet" 
                                    src="/assets/img/layout/add-to-apple-wallet-logo.png" /></a>
        */

        return <React.Fragment>
            <div className="row  mijn-fnv__digitaleledenpas-page">
                <div className="mijn-fnv__mainBlock col-12 col-md-12">
                    
                    <div className="row">
                        <div className="col-12 col-md-6 digitaleledenpas__content">
                            <h2>{this.props.title}</h2>
                            <p>{ReactHtmlParser(this.props.intro)}</p>
                        </div>
                        <div className="col-12 col-md-6 digitaleledenpas__pas">
                            <div className="digitaleledenpas" ref={this.downloadRef}>
                                <div className="digitaleledenpas__info-wrapper">
                                    <div className="digitaleledenpas__title-wrapper">
                                        <h3 className="digitaleledenpas__title">{getResourceString("Memberpass.Members.Text")}
                                            <span className="digitaleledenpas__highlight">{getResourceString("Memberpass.Pass.Text")}</span>
                                        </h3>
                                        <img src="/assets/img/layout/logo.svg" alt="" />
                                    </div>
                                    <DigitaleLedenpasLidnummerNaam
                                        email = ""
                                        lidnummer = {this.state.lidnummer}
                                        name = {this.state.name}
                                        accessToken = ""
                                        isLoggedIn = {false}
                                        birthDate = {this.state.birthDate}
                                        membershipCardActivatedDate = {this.state.membershipCardActivatedDate}
                                        userId  = ""
                                        roles= {[]}
                                    ></DigitaleLedenpasLidnummerNaam>
                                </div>
                                <QRCodeContainer></QRCodeContainer>                                                            
                            </div>
                            <a href="#" onClick={download} className="digitaleledenpas__printledenpas">{getResourceString("Memberpass.Download.Text")}</a>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>;
    }
}

ContainedMijnFNVDigitaleLedenPasBlock.contextType = MijnFNVPageContext;

export const MijnFNVDigitaleLedenPasBlock = connect(mapStateToProps)(ContainedMijnFNVDigitaleLedenPasBlock);